export default __webpack_public_path__ + "static/media/98-05_header_invoice.092f601a.png";